<footer class="footer">
    <div class="container">
        <div class="row justify-content-between">
            <div class="col-md-3">
                <a href="">
                    <img src="assets/images/logo/logo-white.png" alt="Logo">
                </a>
                <p>At FastGo, we believe in providing our clients with personalized and efficient logistics solutions
                    that meet their unique needs.</p>
            </div>
            <div class="col-md-2">
                <h5>Navigation</h5>
                <h6>Home</h6>
                <h6>About Us</h6>
                <h6>Contact Us</h6>

            </div>
        </div>
        <div class="footer-content justify-content-between">
            <p class="m-b-0">Copyright © 2024 Adpedia digital Solutions. All rights reserved.</p>
            <span>
                <a href="" class="text-gray m-r-15">Term &amp; Conditions</a>
                <a href="" class="text-gray">Privacy &amp; Policy</a>
            </span>
        </div>
    </div>
</footer>